import type { InternalAxiosRequestConfig, AxiosInstance } from 'axios'
import axios, { AxiosResponse } from 'axios'
import type { RequestConfig, RequestInterceptors, CreateRequestConfig } from './type'

class Request {
  // axios 实例
  instance: AxiosInstance
  // 拦截器对象
  interceptorsObj?: RequestInterceptors<AxiosResponse>

  constructor(config: CreateRequestConfig) {
    this.instance = axios.create(config)
    this.interceptorsObj = config.interceptors
    // 使用实例拦截器
    this.instance.interceptors.request.use(
      this.interceptorsObj?.requestInterceptors,
      this.interceptorsObj?.requestInterceptorsCatch
    )
    this.instance.interceptors.response.use(
      this.interceptorsObj?.responseInterceptors,
      this.interceptorsObj?.responseInterceptorsCatch
    )

    // 拦截器执行顺序 接口请求 -> 实例请求 -> 全局请求 -> 实例响应 -> 全局响应 -> 接口响应
    this.instance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => config,
      (err: any) => err
    )

    // 全局响应拦截器保证最后执行
    this.instance.interceptors.response.use(
      (res: AxiosResponse) => {
        return res
      },
      (err: any) => err
    )
  }
}

export default Request
export { RequestConfig, RequestInterceptors }
